























































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { ProjectService } from "@/services/project-service";
import { Project } from "@/models/project";
import { ProjectsParams } from "@/models/projects-params";
import UserBasic from "@/components/UserBasic.vue";
import { subject as an } from "@casl/ability";

@Component({
  name: "ProjectsList",
  components: {
    UserBasic,
  },
})
export default class ProjectsList extends Vue {
  @Prop()
  private isPortfolio!: boolean;

  private isBusy = false;

  totalRows = 1;
  currentPage = 1;
  perPage = 20;
  pageOptions = [10, 20, 50];
  sortBy = "updated_on";
  sortDesc = true;
  sortDirection = "asc";
  filter = new Array(26).fill("");
  buOptions = [{value:'', text:'Please select an option'}]

  filterOptions = [
    { text: "Progress Filters", value: "PF" },
    { text: "Time Filters", value: "TF" },
    { text: "Cost Filters", value: "CF" },
  ];
  selectedFilters: string[] = [];

  projectsList: Array<Project> = new Array<Project>();

  project_service: ProjectService = new ProjectService();
  project_params: ProjectsParams = new ProjectsParams();

  totalCap = 0;
  totalET = 0;
  totalST = 0;
  totalWPS = 0;
  totalCost = 0;
  totalEBITDA = 0;

  showSales = false;

  created() {
    this.getProjects();
  }

  mounted() {
    console.log("Portfolio", this.isPortfolio);
  }

  getProjects() {
    this.isBusy = true;
    this.project_params = new ProjectsParams();
    this.projectsList = new Array<Project>();
    this.project_service
      .getProjects(this.project_params)
      .then((response) => {
        if (response.data) {
          response.data.forEach((project: Project) => {
            if (this.$ability.can("read", an("Project", project))) {
              // FIXME as usual, we need to clarify why we need 'an'
              const realProject = new Project();
              Object.assign(realProject, project);
              this.projectsList.push(realProject);
              if (this.isPortfolio && !this.buOptions.find(o => o.value === realProject.business_unit)){
                this.buOptions.push({value: realProject.business_unit, text:realProject.business_unit})
              }
            }
          });
        }
        this.isBusy = false;
      })
      .catch((error) => {
        console.log(error);
        this.isBusy = false;
      });
  }

  get cptProjects() {
    if (this.projectsList) {
      this.totalRows = this.projectsList.length;
      return this.projectsList.map((project: Project) => {
        const tmpProject = project;
        tmpProject._cellVariants = {};
        if (tmpProject.effort_cap == 0) {
          tmpProject._cellVariants.effort_cap = "dark";
        }
        tmpProject.done_ratio === 100
          ? (tmpProject._cellVariants.done_ratio = "success")
          : "";
        tmpProject.estimated_hours > tmpProject.effort_cap
          ? (tmpProject._cellVariants.estimated_hours = "danger")
          : "";
        tmpProject.spent_hours > tmpProject.estimated_hours
          ? (tmpProject._cellVariants.spent_hours = "danger")
          : "";
        tmpProject.expected_hours > tmpProject.hours_left
          ? (tmpProject._cellVariants.expected_hours = "danger")
          : "";
        tmpProject.eff_03 >= 200
          ? (tmpProject._cellVariants.eff_03 = "dark")
          : tmpProject.eff_03 >= 150
          ? (tmpProject._cellVariants.eff_03 = "danger")
          : tmpProject.eff_03 >= 100
          ? (tmpProject._cellVariants.eff_03 = "warning-orange")
          : tmpProject.eff_03 >= 80
          ? (tmpProject._cellVariants.eff_03 = "warning")
          : (tmpProject._cellVariants.eff_03 = "success");
        tmpProject.eff_04 >= 200
          ? (tmpProject._cellVariants.eff_04 = "dark")
          : tmpProject.eff_04 >= 150
          ? (tmpProject._cellVariants.eff_04 = "danger")
          : tmpProject.eff_04 >= 100
          ? (tmpProject._cellVariants.eff_04 = "warning-orange")
          : tmpProject.eff_04 >= 80
          ? (tmpProject._cellVariants.eff_04 = "warning")
          : (tmpProject._cellVariants.eff_04 = "success");
        if (tmpProject.ebitda) {
          tmpProject.ebitda < 0
            ? (tmpProject._cellVariants.ebitda = "danger")
            : tmpProject.wps_done > 0 &&
              tmpProject.ebitda / tmpProject.wps_done < 0.5
            ? (tmpProject._cellVariants.ebitda = "warning")
            : (tmpProject._cellVariants.ebitda = "success");
        }
        if (tmpProject.ebitda_with_sales) {
          tmpProject.ebitda_with_sales < 0
            ? (tmpProject._cellVariants.ebitda_with_sales = "danger")
            : tmpProject.wps_done > 0 &&
              tmpProject.ebitda_with_sales / tmpProject.wps_done < 0.5
            ? (tmpProject._cellVariants.ebitda_with_sales = "warning")
            : (tmpProject._cellVariants.ebitda_with_sales = "success");
        }
        return tmpProject;
      });
    }
    return this.projectsList;
  }

  goToProjectIssues(
    projectId: string,
    projectName: string,
    projectDescription: string,
    estimated_hours: number,
    progress: number,
    spent_hours: number,
    eff_03: number,
    eff_04: number,
    eff_05: number
  ) {
    let eff03Style = "",
      eff04Style = "";
    eff_03 >= 200
      ? (eff03Style = "background-color: #7E7E7E; color: white;")
      : eff_03 >= 150
      ? (eff03Style = "background-color: #B82507; color: white;")
      : eff_03 >= 100
      ? (eff03Style = "color: #EAA00B")
      : eff_03 >= 80
      ? (eff03Style = "color: #EBEB00")
      : (eff03Style = "color: #5DAB1B");
    eff_04 >= 200
      ? (eff04Style = "background-color: #7E7E7E; color: white;")
      : eff_04 >= 150
      ? (eff04Style = "background-color: #B82507; color: white;")
      : eff_04 >= 100
      ? (eff04Style = "color: #EAA00B")
      : eff_04 >= 80
      ? (eff04Style = "color: #EBEB00")
      : (eff04Style = "color: #5DAB1B");
    this.$router.push({
      name: "projectIssues",
      params: { id: projectId },
      query: {
        name: projectName,
        description: projectDescription,
        estimatedHours: estimated_hours.toString(),
        progress: progress.toString(),
        spentHours: spent_hours.toString(),
        eff03: eff_03.toString(),
        eff04: eff_04.toString(),
        eff05: eff_05.toString(),
        eff03Style: eff03Style,
        eff04Style: eff04Style,
      },
    });
  }

  goToProjectRoadmap(projectId: string, projectName: string) {
    this.$router.push({
      name: "versions",
      params: { id: projectId },
      query: { name: projectName },
    });
  }

  calculateTotal(projects: Project[]) {
    this.totalCap = 0;
    this.totalET = 0;
    this.totalST = 0;
    this.totalWPS = 0;
    this.totalCost = 0;
    this.totalEBITDA = 0;
    projects.forEach((p) => {
      //I use +p.effort_cap, because p_effort_cap is a string, why???
      this.totalCap += +p.effort_cap;
      this.totalET += p.estimated_hours;
      this.totalST += p.spent_hours;
      this.totalWPS += p.wps_done;
      this.totalCost += p.normalized_cost;
      this.totalEBITDA += p.ebitda;
    });
  }

  onSelectChange() {
    if (!this.selectedFilters.includes("PF")) {
      this.filter.fill("", 4, 13);
    }
    if (!this.selectedFilters.includes("TF")) {
      this.filter.fill("", 14, 19);
    }
    if (!this.selectedFilters.includes("CF")) {
      this.filter.fill("", 20, 25);
    }
  }

  filterTable(row: Project) {
    const mapStrings = new Map<number, string>();
    mapStrings.set(0, row.name);
    mapStrings.set(1, row.description);
    mapStrings.set(2, row.business_unit);
    mapStrings.set(3, row.project_type);
    const mapPF = new Map<number[], number>();
    mapPF.set([4, 5], (row.estimated_hours / row.effort_cap) * 100);
    mapPF.set([6, 7], (row.spent_hours / row.estimated_hours) * 100);
    mapPF.set([8, 9], row.done_ratio);
    mapPF.set([10, 11], (row.wps_done / row.wps_total) * 100);
    mapPF.set([12, 13], row.ebitda_ratio * 100);
    const mapTF = new Map<number[], number>();
    mapTF.set([14, 15], +row.effort_cap);
    mapTF.set([16, 17], row.estimated_hours);
    mapTF.set([18, 19], row.spent_hours);
    const mapCF = new Map<number[], number>();
    mapCF.set([20, 21], row.wps_done);
    mapCF.set([22, 23], row.normalized_cost);
    mapCF.set([24, 25], row.ebitda);
    return (
      this.stringContainFilterMap(mapStrings) &&
      (!this.selectedFilters.includes("PF") || this.rangeFilterMap(mapPF)) &&
      (!this.selectedFilters.includes("TF") || this.rangeFilterMap(mapTF)) &&
      (!this.selectedFilters.includes("CF") || this.rangeFilterMap(mapCF))
    );
  }

  get fields() {
    if (this.isPortfolio) {
      let fieldsArray = [
        { key: "actions", label: "" },
        { key: "business_unit", label: "Business Unit", sortable: true },
        // TODO project state
        { key: "name", label: "Name", tdClass: "td-bold", sortable: true },
        { key: "project_type", label: "Type", sortable: true },
        { key: "description", label: "Description" },
        {
          key: "effort_cap",
          label: "Effort cap (hours)",
          headerAbbr: "Cap",
          tdClass: "td-bold",
          sortable: true,
        },
        {
          key: "estimated_hours",
          label: "Estimated time (hours)",
          headerAbbr: "ET",
          sortable: true,
        },
        {
          key: "spent_hours",
          label: "Spent time (hours)",
          headerAbbr: "ST",
          sortable: true,
        },
        { key: "done_ratio", label: "Done ratio", sortable: true },
        { key: "wps_done", label: "WPS progress", sortable: true },
        // TODO risk indicator
        {
          key: "normalized_cost",
          label: "Cost",
          tdClass: "td-bold",
          sortable: true,
        },
        { key: "ebitda", label: "EBITDA", tdClass: "td-bold", sortable: true },
        { key: "sales_cost", label: "Sales Cost", tdClass: "td-bold", sortable: true},
        { key: "ebitda_with_sales", label: "EBITDA(S)", tdClass: "td-bold", sortable: true},
        { key: "updated_on", label: "Updated on", sortable: true },
      ];
      if (!this.showSales){
        fieldsArray = fieldsArray.filter(f=> f.key !== "sales_cost" && f.key!=="ebitda_with_sales")
      }
      return fieldsArray;
    } else {
      // Operation Projects
      return [
        { key: "actions", label: "Actions" },
        { key: "name", label: "Name", tdClass: "td-bold", sortable: true },
        { key: "vips", label: "VIPs" },
        {
          key: "effort_cap",
          label: "Effort cap (hours)",
          headerAbbr: "Cap",
          tdClass: "td-bold",
          sortable: true,
        },
        {
          key: "estimated_hours",
          label: "Estimated time (hours)",
          headerAbbr: "ET",
          sortable: true,
        },
        {
          key: "spent_hours",
          label: "Spent time (hours)",
          headerAbbr: "ST",
          sortable: true,
        },
        { key: "done_ratio", label: "Done ratio", sortable: true },
        { key: "wps_done", label: "WPS progress", sortable: true },
        { key: "hours_left", label: "Hours left", sortable: true },
        { key: "expected_hours", label: "Expected hours", sortable: true },
        { key: "eff_03", label: "EFF_03", tdClass: "td-bold", sortable: true },
        { key: "eff_04", label: "EFF_04", tdClass: "td-bold", sortable: true },
        { key: "eff_05", label: "EFF_05", sortable: true },
        { key: "business_unit", label: "Business Unit", sortable: true },
        { key: "updated_on", label: "Updated on", sortable: true },
      ];
    }
  }

  goToPortfolioProjectDetails(project: Project) {
    this.$router.push({
      name: "portfolioProject",
      params: { id: project.id },
    });
  }

  onFiltered(filteredItems: Project[]) {
    this.calculateTotal(filteredItems);
  }

  clearFilterArray() {
    this.filter = new Array(26).fill("");
  }

  rangeFilterMap(map: Map<number[], number>): boolean {
    let result = true;
    map.forEach((value: number, key: number[]) => {
      result = result && this.rangeFilter(key[0], key[1], value);
    });
    return result;
  }

  rangeFilter(
    indexMin: number,
    indexMax: number,
    value: number | undefined
  ): boolean {
    return (
      value == undefined ||
      ((!this.filter[indexMin] || value >= this.filter[indexMin]) &&
        (!this.filter[indexMax] || value <= this.filter[indexMax]))
    );
  }

  stringContainFilterMap(map: Map<number, string>): boolean {
    let result = true;
    map.forEach((value: string, key: number) => {
      result = result && this.stringContainFilter(key, value);
    });
    return result;
  }

  stringContainFilter(index: number, value: string | undefined): boolean {
    return (
      !this.filter[index] ||
      value == undefined ||
      value.toLowerCase().includes(this.filter[index].toLowerCase())
    );
  }
}
